import { ON_ADD_PAYMENT, ON_ADD_PAYMENT_SUCCESS } from "../../constants/ActionTypes";


  
  export const AddPayment = (missionId) => {
    return {
      type: ON_ADD_PAYMENT,
      payload: missionId
    };
  };

  export const AddPaymentSuccess = (url) => {
    return {
      type: ON_ADD_PAYMENT_SUCCESS,
      payload: url
    };
  };